export const PETITION_URL = "https://rustlangsa1.petities.nl/";

export const IMAGES = {
  hero: "/images/a1-hero.jpg",
  nature: "/images/wijk-context.jpg",
  asphalt: "/images/a1-wide.jpg",
};

// A/B-test: elke bezoeker krijgt willekeurig variant A, B of C (vastgelegd in localStorage).
// Conversie per variant is zichtbaar op /statistieken. ACTIVE_HERO_VARIANT is de fallback.
export const HERO_VARIANTS = {
  A: ["1 minuut langer rijden.", "Iedere dag meer rust."],
  B: ["7 kilometer 80 km/u.", "Voor duizenden omwonenden meer rust."],
  C: ["Wat is één minuut waard", "voor meer rust langs de A1?"],
};
export const ACTIVE_HERO_VARIANT = "A";
